import Player from '@vimeo/player';
import BlockCover from '../plugins/BlockCover';
import type { PlayerMask } from '../utils/VideoUtils';
import { includeYTScript } from '../utils/VideoUtils';

export default function initHero() {
  Alpine.data('hero', () => ({
    player: null as PlayerMask | null,
    playing: true,
    videoReady: false,
    videoWrap: null as HTMLElement | null,
    initVideo(videoId: string, providerName: string) {
      const videoWrap = this.$el.querySelector('.video-player');
      if (videoWrap) {
        // @ts-ignore
        this.videoWrap = videoWrap as HTMLElement;
        if (providerName.toLowerCase().includes('youtube')) {
          includeYTScript();

          Alpine.effect(() => {
            if (Alpine.store('ytPlayerReady') && !this.player && this.videoWrap) {
              this.player = new YT.Player(this.videoWrap.id, {
                  videoId,
                  playerVars: {
                    'controls': 0,
                    'disablekb': 1,
                    'enablejsapi': 1,
                    'rel': 0,
                    'mute': 1,
                    'loop': 1,
                    'modestbranding': 1,
                    'playlist': videoId,
                  },
                  events: {
                    'onReady': () => this.onPlayerReady(),
                  }
              });
            }
          });
        } else {
          // Proxy that vimeo returns gets unmounted when set directly to the this.player,
          // so we needed to create a wrapper object to call the play and pause methods on it
          const player = new Player(this.videoWrap);
          this.player = {
            playVideo: () => { player.play(); },
            pauseVideo: () => { player.pause(); },
            getIframe: () => videoWrap,
          } as unknown as PlayerMask;
          this.onPlayerReady();
        }
      }
    },
    onPlayerReady() {
      if (!this.player) {
        return;
      }
      this.videoReady = true;
      /* eslint-disable no-new */
      new BlockCover(this.player.getIframe());
      this.player.playVideo();
    },
    togglePlay() {
      if (this.videoReady && this.player) {
        if (this.playing) {
            this.player.pauseVideo();
        } else {
            this.player.playVideo();
        }
        this.playing = !this.playing;
      }
    },
  }));
}
